import { initReactI18next } from "react-i18next";

import i18n from "i18next";

import { getStoredLanguage, storeLanguage } from "@/utils/languageStorage";

import en from "./locales/en.json";
import es from "./locales/es.json";

const SUPPORTED_LANGUAGES = ["en", "es"] as const;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: getStoredLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", storeLanguage);

export { SUPPORTED_LANGUAGES };
export default i18n;
